import { RIGHTS, type SystemProperty, type User } from 'interfaces/Interfaces';

export const FORECAST_PROPERTY_NAME = 'dunning.execution.forecast.enabled';

export function isDunningForecastEnabled(forecastProperty?: SystemProperty): boolean {
  return forecastProperty?.value === 'true';
}

export function canAccessDunningForecast(user: User, forecastProperty?: SystemProperty): boolean {
  return isDunningForecastEnabled(forecastProperty) || user.rights.includes(RIGHTS.ACCESS_SETTINGS);
}
